/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';

class TwitterFubarModal extends React.Component {
    constructor(props) {
        super(props);

        this.dismissModal = this.dismissModal.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

    }

    componentDidMount() {
        document.addEventListener('keyup', this.onKeyUp);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    onKeyUp(e) {

        if (e.key === "Escape") {
            this.dismissModal();
        }

    }

    dismissModal(e) {
        let cookieData = {
                hideTwitterFubarNotice: 1
            },
            expiration = new Date(new Date().getTime() + 60*60*1000*24).toGMTString(),
            domain = this.props.app.config.cookieDomain;

        // set cookie to not show this
        // close modal
        if (document.cookie) {
            window.document.cookie = 'twitterNotice=' + encodeURIComponent(JSON.stringify(cookieData)) + "; expires=" + expiration + "; path=/; domain=" + domain + ";";
        }

        this.props.dismissModal();

    }

    render() {
        let modalContent = null;

        modalContent = (
            <div className="facebook-warning">
                <div className="big-icon">
                    <div className="big-icon-bg">
                        <i className="ds-icon icon-dlvr"></i>
                    </div>
                </div>
                <div className="warning-content">
                  <p style={{"fontWeight": 500}}>We are experiencing issues with the X (Twitter) API</p>
                    <p>{"Due to these issues dlvr.it is currently not sending posts to X (Twitter). We’re working to resolve this issue and will provide updates"} <a href="https://support.dlvrit.com/hc/en-us/articles/26790607785243-X-Twitter-Outage-June-21st-2024" target="_blank">on our support site.</a></p>
                </div>
                <div className="warning-dismiss" onClick={this.dismissModal} role="button" aria-label="close">
                    OK
                </div>
            </div>
        )

        return (
            <Modal
                content={modalContent}
                boxClass={"facebook-modal-box"}
                mainClass={"facebook-modal-content"} />
        );
    }
}

TwitterFubarModal.displayName = "TwitterFubarModal";

export default TwitterFubarModal;
